import { atom } from "recoil";

export const openModalCollectionState = atom({
    key:'openModalCollectionState',
    default:false
});

export const geoJsonMapState = atom({
    key:'geoJsonMapState',
    default:{}
});

export const sortConfigParcelleAtom = atom({
    key: 'sortConfigParcelleAtom', 
    default: null,         
});

export const currentPageParcelleAtom = atom({
    key: 'currentPageParcelleAtom', 
    default: 1, 
});